module.exports = __webpack_public_path__ + "img/tech.98930f08.svg";